import { convertToRaw, ContentState, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
export const toHtml = (state) => {
    return draftToHtml(convertToRaw(state.getCurrentContent()));
};
export const toPlaintext = (state) => {
    return state.getCurrentContent().getPlainText();
};
export const fromHtml = (html) => {
    return EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(html).contentBlocks));
};
//# sourceMappingURL=utils.js.map